import { Timestamp } from "..";
import { IRouteItem } from ".";
import { IOrderProduct } from "../OrderProduct";
import { ICustomer } from "..";

export interface IOrderAttachment {
  id: string;
  name: string;
  url: string;
  storagePath: string;
  contentType: string;
  size: number;
  uploadedAt: Timestamp | null;
  uploadedBy: string | null;
  deletedAt?: Timestamp | null;
  deletedBy?: string | null;
}

export interface IOrder {
  vehicleRequirements?: import("../../api/vehicleFeatures").VehicleRequirement[];
  vehicleFeatureSchemaRevision?: number;
  id: string;
  customer: ICustomer;
  customerId: string;
  route: IRouteItem[];
  cargo: IOrderProduct[];
  attachments?: IOrderAttachment[];
  driverId?: string;
  companyId?: string | null;
  comment: string;
  projectNumber?: string;
  status: OrderStatus;
  createdAt: Timestamp | null;
  createdBy: string | null;
  lastUpdated: Timestamp | null;
  completedAt?: Timestamp | null;
  workspaceId: string;
  price?: number | null;
  pricing?: {
    priceModel: string | string[];
  };
  orderPricing?: {
    priceModel: string | string[];
    pricePerDistanceUnit: number;
    pricePerTimeUnit?: number;
    timePeriodInMinutes?: number;
    vat: number;
  };
  orderNumber?: string | null;
  isInvoiced?: boolean;
  orderType?: OrderType;
  intakeReference?: string | null;
  intakeReferenceNormalized?: string | null;
  /** Id of the recurring order template that generated this order, if any. */
  recurrenceTemplateId?: string | null;
  /** Occurrence date (`YYYY-MM-DD`) this order was generated for; dedupe key. */
  occurrenceDate?: string | null;
}

export enum OrderStatus {
  Draft = "Draft",
  New = "New",
  Scheduled = "Scheduled",
  InProgress = "InProgress",
  Completed = "Completed",
  Cancelled = "Cancelled",
}

export enum OrderType {
  PriceRequest = "PriceRequest",
  PublicOrder = "PublicOrder",
  Order = "Order",
}

export interface IContactPerson {
  name: string;
  location?: string;
  phoneNumber: string;
}

export interface IOrderValidated {
  customer?: boolean;
  route?: boolean;
  cargo?: boolean;
  driver?: boolean;
  deliveryDate?: boolean;
}
